import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {Erreur404Component} from './pages/erreur404/erreur404.component';
import {FaqsComponent} from './pages/faqs/faqs.component';
import {PipeModule} from './core/pipes/pipe.module';
import {AboutUsComponent} from './pages/about-us/about-us.component';
import {DataProtectionComponent} from './pages/data-protection/data-protection.component';
import {MentionLegalesComponent} from './pages/mention-legales/mention-legales.component';
import {MondatsComponent} from './pages/mondats/mondats.component';
import {ConcessionaireComponent} from './pages/concessionaire/concessionaire.component';
import {NoAuthGuard} from './core/auth/guards/noAuth.guard';
import {AuthGuard} from './core/auth/guards/auth.guard';
import {SitemapComponent} from "./pages/sitemap/sitemap.component";
import {TarifsDepartementsComponent} from "./pages/tarifs-departements/tarifs-departements.component";
import {DesabonnementComponent} from "./pages/desabonnement/desabonnement.component";
import {SatisfactionComponent} from "./pages/satisfaction/satisfaction.component";
import {AgenceByTdmComponent} from "./pages/agence-by-tdm/agence-by-tdm.component";
import {ByTdmComponent} from "./pages/by-tdm/by-tdm.component";
import {ContactByTdmComponent} from "./pages/contact-by-tdm/contact-by-tdm.component";

const routes: Routes = [
  {path: '', redirectTo: '/accueil', pathMatch: 'full'},
  {
    path: 'agence-by-tdm/:nomAgence',
    component: AgenceByTdmComponent
  },
  {
    path: 'by-tdm',
    component: ByTdmComponent
  },
  {
    path: 'by-tdm/contact',
    component: ContactByTdmComponent
  },
  {
    path: 'nos-concessions/:concession/:dep/:user/contact.html',
    redirectTo: 'nos-concessions/:concession/:dep',
    pathMatch: 'full',
  },
  {
    path: 'accueil',
    loadChildren: () =>
      import('./modules/home/home.module').then((m) => m.HomeModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/biens/biens.module').then((m) => m.BiensModule),
  },
  {
    path: 'amis-tdm',
    loadChildren: () =>
      import('./modules/amis/amis.module').then((m) => m.AmisModule),
  },
  {
    path: 'espace-personnel/:username/:section',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/blog/blog.module').then((m) => m.BlogModule),
  },
  {
    path: 'faq-the-door-man.html',
    component: FaqsComponent,
  },
  {
    path: 'le-concept-the-door-man.html',
    component: AboutUsComponent,
  },
  {
    path: 'charte-protection-données.html',
    component: DataProtectionComponent,
  },
  {
    path: 'mentions-legales-the-door-man.html',
    component: MentionLegalesComponent,
  },
  {
    path: 'nos-formules-the-door-man.html',
    component: MondatsComponent,
  },
  {
    path: 'plan-du-site-the-door-man.html',
    component: SitemapComponent,
  },
  {
    path: 'desabonnement',
    component: DesabonnementComponent,
  },
  {
    path: 'questionnaire-satisfaction/:idclient/:idbien/:token',
    component: SatisfactionComponent,
  },

  {
    path: 'nos-concessions/honoraires',
    component: TarifsDepartementsComponent,
  },
  {
    path: 'nos-concessions/liste.html',
    redirectTo: 'amis-tdm/liste',
    pathMatch: 'full',
  },
  {
    path: 'nos-concessions/:concession/:dep/honoraires',
    component: TarifsDepartementsComponent,
  },
  {
    path: 'nos-concessions/:concession/:dep/honoraires.html',
    redirectTo: 'nos-concessions/:concession/:dep/honoraires',
    pathMatch: 'full',
  },
  {
    path: 'nos-concessions/:concession/:dep/contact.html',
    redirectTo: 'nos-concessions/:concession/:dep',
    pathMatch: 'full',
  },
  {
    path: 'nos-concessions/:concession/:dep',
    component: ConcessionaireComponent,
  },
  {
    path: 'nos-concessions/:concession',
    component: ConcessionaireComponent,
  },
  // Rediriger "nos-concessions" vers amis-tdm/liste
  {
    path: 'nos-concessions',
    redirectTo: 'amis-tdm/liste',
    pathMatch: 'full',
  },
  {
    path: 'utilisateur/creation-compte/pro',
    redirectTo: '/contact#Partenariat',
    pathMatch: 'full',
  },
  {
    path: 'utilisateur/creation-compte',
    redirectTo: 'amis-tdm/liste',
    pathMatch: 'full',
  },
  {
    path: 'nous-rejoindre',
    redirectTo: '/contact#Nous-contacter',
    pathMatch: 'full',
  },
  {
    path: 'nous-rejoindre/agent-master.html',
    redirectTo: '/contact#Nous-contacter',
    pathMatch: 'full',
  },
  {
    path: 'contact-the-door-man.html',
    redirectTo: '/contact#Nous-contacter',
    pathMatch: 'full',
  },
  {
    path: 'vous-etes-vendeur-the-door-man.html',
    redirectTo: '/accueil',
    pathMatch: 'full',
  },
  {
    path: 'agent-immo.html',
    redirectTo: 'amis-tdm/liste',
    pathMatch: 'full',
  },
  {
    path: 'notre-equipe',
    redirectTo: 'amis-tdm/liste',
    pathMatch: 'full',
  },
  {
    path: 'contact',
    loadChildren: () =>
      import('./pages/contact/contact.module').then((m) => m.ContactModule),
  },

  // Auth routes for guests
  {
    path: '',
    canActivate: [NoAuthGuard],
    children: [
      {
        path: 'connexion',
        loadChildren: () =>
          import('./modules/auth/sign-in/sign-in.module').then(
            (m) => m.AuthSignInModule
          ),
      },
      {
        path: 'mot-de-passe-oublie',
        loadChildren: () =>
          import('./modules/auth/reset-password/reset-password.module').then(
            (m) => m.AuthResetPasswordModule
          ),
      },
      {
        path: 'verification',
        loadChildren: () =>
          import(
            './modules/auth/verification-password/verification-password.module'
            ).then((m) => m.VerificationPasswordModule),
      },
      // {
      //   path: 'creation-compte',
      //   loadChildren: () =>
      //     import('./modules/auth/sign-up/sign-up.module').then(
      //       (m) => m.AuthSignUpModule
      //     ),
      // },

    ],
  },
  {
    path: 'deconnexion',
    loadChildren: () =>
      import('./modules/auth/sign-out/sign-out.module').then(
        (m) => m.AuthSignOutModule
      ),
  },
  // Auth routes for authenticated users
  {
    path: '',
    canActivate: [AuthGuard],
    children: [],
  },
  {path: '*', redirectTo: '/accueil'},
  {path: '**', redirectTo: '/erreur404', pathMatch: 'full'},
  {path: 'erreur404', pathMatch: 'full', component: Erreur404Component},
];

@NgModule({
  imports: [
    PipeModule,
    RouterModule.forRoot(routes, {
      // scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled', // or 'top'
      scrollOffset: [0, 64], // [x, y] - adjust scroll offset
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
